import React from "react";
import SearchItems from "./SearchItems";
import { useNavigate } from "react-router-dom";
import useAccount from "../../hooks/useAccount";

const CreateNewOrderModal = () => {
  const navigate = useNavigate();
  const {checkPermission} = useAccount();

  const gotoFlights = () => {
    navigate("/order/new/flight");
    // search flights
  };
  const gotoHotels = () => {
    navigate("/accommodation/new");
    // search Hotels
  };
  const gotoTours = () => {
    navigate("/tour/new");
    // search Tours
  };
  const gotoInsurance = () => {
    navigate("/protection/new");
    // search Insurance
  };

  return (
    <div className={`max-w-[887px] sm:w-[900px]`}>
      <div>
        {/* <div className={Classname.header}>
          <div>
            <h2 className={Classname.title}>New Search</h2>
          </div>
          <button onClick={close}>
            <Icon
              icon="material-symbols:close"
              className="text-secondary text-3xl"
            />
          </button>
        </div> */}
        <div className={Classname.content}>
          <div className="flex flex-col sm:flex-row gap-4">
            {checkPermission(['search:flight','book:flight']) ? 
              <SearchItems
                image="/flightsImage.svg"
                borderColor="border-[#0C58AD]"
                detail="Flights"
                onClick={gotoFlights}
                type="search"
              />
            :null}
            <SearchItems
              image="/hotelsImage.svg"
              borderColor="border-[#01A1F1]"
              detail="Accommodation"
              onClick={gotoHotels}
              type="search"
            />
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <SearchItems
              image="/toursImage.svg"
              borderColor="border-[#01A1F1]"
              detail="Tours"
              onClick={gotoTours}
              type="search"
            />
            <SearchItems
              image="/insuranceImage.svg"
              borderColor="border-[#7069F6]"
              detail="Insurance"
              onClick={gotoInsurance}
              type="search"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewOrderModal;

const Classname = {
  modalContent:
    "bg-white w-full max-w-[887px] rounded-b-lg shadow-md max-h-[90vh] mx-4",
  header:
    "bg-primary1 px-2.5 py-1 sm:px-6 sm:py-5 flex justify-between items-center",
  content: "pt-6 px-4 pb-4 sm:p-16 flex flex-col gap-4",
  title: "font-bold text-secondary text-xs sm:text-2xl",
};
